<div *ngIf="isMobile">
  <app-quote-details-mobile [quoteSummary]="quoteSummary" (updated)="quoteUpdated($event)"></app-quote-details-mobile>
</div>
<div *ngIf="!isMobile">
  <!--<app-quote-details-desktop></app-quote-details-desktop>-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-9 quote-section">
        <div class="row quote-header" i18n>Quote</div>
        <div class="row">
          <div class="p-2">
            <span i18n>Add product items to your quote.</span>
            <button *ngIf="!readOnly" class="ml-2 btn btn-bidit-navigate" (click)="openAreaDialog(null)" i18n>Add Product Item</button>

            <label for="quote_roundMaterials" class="col-form-label" i18n>Round Materials</label>
            <mat-radio-group (change)="materialsRoundingChanged()" name="quote_roundMaterials"
                             [disabled]="readOnly"
                             [(ngModel)]="quote.roundMaterials">
              <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
              <mat-radio-button [value]="false" i18n>No</mat-radio-button>
            </mat-radio-group>

            <div class="form-inline float-right" *ngIf="quote.acknowledgementStatus">
              <div class="mr-3"><span class="col-form-label" i18n>Acknowledgement Status: </span> {{quote.acknowledgementStatus}}</div>
              <div *ngIf="this.quote.quoteAcknowledgedDate">
                <span class="col-form-label" i18n>Acknowledgement Date: </span><span class="mr-5"> {{quote.acceptedQuoteRejectedDate ?? quote.quoteAcknowledgedDate | date:'MM/dd/yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="float-right form-inline">
          <div *ngIf="!quote.quote_IsTemplate" class="form-row mr-4">
            <label for="lostStatus" class="col-form-label" i18n>Quote Status</label>
            <select class="form-control select-bidit" name="lostStatus" id="lostStatus"
                    [disabled]="readOnly"
                    [(ngModel)]="lostStatus"
                    (change)="quoteStatusChanged()">
              <option value="" i18n>Active</option>
              <option value="L" i18n>Lost</option>
              <option *ngIf="quoteOnly" value="W" i18n>Won</option>
            </select>
            <button *ngIf="(!readOnly || isQuoteAcknowledged) && canAddJob && quote.quote_Converted === null" (click)="recalcQuote()" class="ml-2 btn btn-bidit-action btn-md" i18n>Refresh</button>
          </div>
        </div>
        <div cdkDropList [cdkDropListData]="areaSummaries" (cdkDropListDropped)="dropArea($event)">
          <div cdkDrag [cdkDragDisabled]="area.area_Sort == 99" *ngFor="let area of areaSummaries">
            <div *ngIf="!area.area_IsOption">
              <h5 class="mb-0">
                {{area.area_Name}}
              </h5>
              <div class="scrollable">
                <table class="table table-quote-area" cdkDropList [cdkDropListData]="area.quoteAreas" (cdkDropListDropped)="dropItem($event)">
                  <thead>
                    <tr>
                      <th i18n>Sub Area</th>
                      <th i18n>R-Value</th>
                      <th i18n>Product</th>
                      <th i18n>Sqr Ftg</th>
                      <ng-container *ngIf="area.area_IsOption; then optionsHeader; else defaultHeader"></ng-container>
                      <ng-template #optionsHeader>
                        <th i18n>Estimate Change</th>
                        <th i18n>Cost Change</th>
                      </ng-template>
                      <ng-template #defaultHeader>
                        <th i18n>Addl Items</th>
                        <th i18n>Cost</th>
                      </ng-template>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--- check if the area is the options default --->
                    <ng-template ngFor let-quoteArea [ngForOf]="area.quoteAreas">

                      <tr cdkDrag [ngClass]="{'alert': area.area_IsAccepted == 0}">
                        <td>
                          <p *ngIf="quoteArea.quoteItem.subArea">{{quoteArea.quoteItem.subArea.subArea_Name}} <span *ngIf="quoteArea.quoteItem.area_Name"> - {{quoteArea.quoteItem.area_Name}}</span></p>
                        </td>
                        <td>
                          <p *ngIf="quoteArea.quoteItem.itemUsage; then usageBlock; else rValueBlock"></p>
                          <ng-template #usageBlock>{{quoteArea.quoteItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                          <ng-template #rValueBlock>
                            <span *ngIf="quoteArea.quoteItem.item && quoteArea.quoteItem.item.rValue">
                              {{quoteArea.quoteItem.item.rValue.rValue_Desc}}
                            </span>
                          </ng-template>
                        </td>
                        <td>
                          <p>
                            <ng-template [ngIf]="quoteArea.quoteItem.item">
                              <span *ngIf="quoteArea.quoteItem.item.item_Part">{{quoteArea.quoteItem.item.item_Part}},</span>
                              {{quoteArea.quoteItem.item.item_Name}}
                            </ng-template>
                            <ng-template [ngIf]="!quoteArea.quoteItem.item">
                              {{quoteArea.quoteItem.area_Note}}
                            </ng-template>
                          </p>
                        </td>
                        <td>
                          {{quoteArea.quoteItem.area_SqrFtg | number: '1.2' }}
                        </td>
                        <td>
                          <div *ngIf="area.area_IsOption; else defaultAccessories">
                            ${{quoteArea.quoteItem.optionBid | number: '1.2' }}
                          </div>
                          <ng-template #defaultAccessories>
                            {{quoteArea.quoteItem.accessories.length}}
                          </ng-template>
                        </td>
                        <td>
                          <div *ngIf="showLinePricing">
                            <span>${{quoteArea.quoteItem.area_TotalCost | number: '1.2' }}</span>
                          </div>
                        </td>
                        <td>
                          <span *ngIf="!readOnly">
                            <button class="btn btn-bidit-edit" (click)="openAreaDialog(quoteArea.quoteItem.quoteAreaItem_ID)" title="Edit product" i18n-title></button>
                            <button class="btn btn-bidit-delete" (click)="deleteArea(quoteArea.quoteItem.quoteAreaItem_ID)" title="Remove product" i18n-title></button>
                            <button *ngIf="!area.area_IsOption" class="btn btn-bidit-add" (click)="addUpgradeDialog(quoteArea)" title="Add alternate to product" i18n-title></button>
                          </span>
                          <!--<span class="material-icons"
                               i18n-matTooltip
                               matTooltip="A sales lead is a potential sales contact who expresses interest in your business' product or services.  Customer information must be added before a lead is entered.">notes</span>-->
                        </td>
                      </tr>
                      <tr *ngFor="let upgrade of quoteArea.quoteUpgrades" class="bidit-alert">
                        <th>
                          <span>ALTERNATE</span>
                          <ng-template [ngIf]="upgrade.area_Name">({{upgrade.area_Name}})</ng-template>
                        </th>
                        <td>
                          <p *ngIf="upgrade.itemUsage; then usageBlock; else rValueBlock"></p>
                          <ng-template #usageBlock>{{upgrade.itemUsage.rValue.rValue_Desc}}</ng-template>
                          <ng-template #rValueBlock>
                            <span *ngIf="upgrade.item.rValue">{{upgrade.item.rValue.rValue_Desc}}</span>
                          </ng-template>
                        </td>
                        <td>
                          <p *ngIf="upgrade.item.item_Part; then upgradeDom else defaultDom"></p>
                          <ng-template #upgradeDom>{{upgrade.item.item_Part}}, {{upgrade.item.item_Name}}</ng-template>
                          <ng-template #defaultDom>{{upgrade.item.item_Name}}</ng-template>
                        </td>
                        <td colspan="3">
                          <div *ngIf="showLinePricing" class="float-right">
                            <span><strong i18n>Estimate Change: </strong>${{upgrade.upgradeBid | number:'1.2-2'}}</span><br>
                            <span><strong i18n>Cost Change: </strong>${{upgrade.upgradeDelta | number:'1.2-2'}}</span>
                          </div>
                        </td>
                        <td>
                          <button *ngIf="!readOnly" class="btn btn-bidit-edit" (click)="openAreaDialog(upgrade.quoteAreaItem_ID)" title="Edit upgrade" i18n-title></button>
                          <button *ngIf="!readOnly" class="btn btn-bidit-delete" (click)="deleteArea(upgrade.quoteAreaItem_ID)" title="Remove upgrade" i18n-title></button>
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="showLinePricing" class="no-border">
                      <td colspan="5"></td>
                      <td><h7><span i18n>Total</span> ${{area.totalCost | number: '1.2-2'}}</h7></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <ng-template ngFor let-areaOptionGroup [ngForOf]="area.quoteAreaOptionGroups">
              <h5 class="mb-0" *ngIf="areaOptionGroup.optionGroup !== null">
                {{area.area_Name}} - {{areaOptionGroup.optionGroup}}
              </h5>
              <h5 class="mb-0" *ngIf="areaOptionGroup.optionGroup === null">
                {{area.area_Name}}
              </h5>
              <div class="scrollable">
                <table class="table table-quote-area">
                  <thead>
                    <tr>
                      <th i18n>Sub Area</th>
                      <th i18n>R-Value</th>
                      <th i18n>Product</th>
                      <th i18n>Sqr Ftg</th>
                      <th i18n>Estimate Change</th>
                      <th i18n>Cost Change</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--- check if the area is the options default --->
                    <ng-template ngFor let-quoteAreaItem [ngForOf]="areaOptionGroup.quoteAreaItems">
                      <tr>
                        <td>
                          <p *ngIf="quoteAreaItem.subArea">{{quoteAreaItem.subArea.subArea_Name}} <span *ngIf="quoteAreaItem.subArea.subArea_Name"> - {{quoteAreaItem.subArea.subArea_Name}}</span></p>
                        </td>
                        <td>
                          <p *ngIf="quoteAreaItem.itemUsage; then usageBlock; else rValueBlock"></p>
                          <ng-template #usageBlock>{{quoteAreaItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                          <ng-template #rValueBlock>
                            <span *ngIf="quoteAreaItem.item && quoteAreaItem.item.rValue">
                              {{quoteAreaItem.item.rValue.rValue_Desc}}
                            </span>
                          </ng-template>
                        </td>
                        <td>
                          <p>
                            <ng-template [ngIf]="quoteAreaItem.item">
                              <span *ngIf="quoteAreaItem.item.item_Part">{{quoteAreaItem.item.item_Part}},</span>
                              {{quoteAreaItem.item.item_Name}}
                            </ng-template>
                            <ng-template [ngIf]="!quoteAreaItem.item">
                              {{quoteAreaItem.area_Note}}
                            </ng-template>
                          </p>
                        </td>
                        <td>
                          {{quoteAreaItem.area_SqrFtg | number: '1.2' }}
                        </td>
                        <td>
                          <div *ngIf="area.area_IsOption && showLinePricing; else defaultAccessories">
                            ${{quoteAreaItem.optionBid | number: '1.2' }}
                          </div>
                          <ng-template #defaultAccessories>
                            {{quoteAreaItem.accessories.length}}
                          </ng-template>
                        </td>
                        <td>
                          <div *ngIf="showLinePricing">
                            <span>${{quoteAreaItem.area_TotalCost | number: '1.2' }}</span>
                          </div>
                        </td>
                        <td>
                          <div *ngIf="!readOnly">
                            <button class="btn btn-bidit-edit" (click)="openAreaDialog(quoteAreaItem.quoteAreaItem_ID)" title="Edit product" i18n-title></button>
                            <button class="btn btn-bidit-delete" (click)="deleteArea(quoteAreaItem.quoteAreaItem_ID)" title="Remove product" i18n-title></button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                  <tfoot>
                    <tr *ngIf="showLinePricing" class="no-border">
                      <td colspan="5"></td>
                      <td><h7><span i18n>Total</span> ${{areaOptionGroup.totalCost | number: '1.2-2'}}</h7></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div *ngIf="!quote.quote_IsTemplate">
          <button *ngIf="!readOnly" (click)="openTemplateDialog()" class="btn btn-bidit-action mr-1" i18n>Create Template</button>
          <button *ngIf="(!readOnly || isQuoteAcknowledged) && canAddJob && quote.quote_Converted === null" (click)="convertQuote()" class="btn btn-bidit-submit btn-md" i18n>Convert to Job</button>
        </div>

        <div *ngIf="showCostBreakdown" class="cost-breakdown-pnl">
          <h5 align="center" i18n>COST BREAKDOWN</h5>
          <table class="table table-bidit">
            <tbody>
              <tr>
                <td i18n>Material Cost:</td>
                <td>${{quote.materialCost | number: '1.2'}} ({{100 * quote.materialCost / quote.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Labor Cost:</td>
                <td>${{quote.laborCost | number: '1.2'}} ({{100 * quote.laborCost / quote.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Other Cost:</td>
                <td>${{quote.otherCost | number: '1.2'}} ({{100 * quote.otherCost / quote.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Total Cost:</td>
                <td>${{quote.totalCost | number: '1.2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="estimate-pnl">
          <h5 align="center" i18n>ESTIMATE</h5>
          <table class="table table-bidit">
            <tbody>
              <tr *ngIf="showLinePricing">
                <td i18n>Total Cost:</td>
                <td>${{quote.totalCost | number: '1.2'}}</td>
              </tr>
              <tr *ngIf="showMargins">
                <td i18n>Gross Margin:</td>
                <td>
                  <div *ngIf="showMarginEdit==false">
                    <a *ngIf="!readOnly" class="float-left" href="javascript:void(0);" (click)="editMargin()" i18n>Edit</a>

                    <span class="float-right">{{quote.quote_GrossMargin | number: '1.0-4'}}%</span>
                  </div>
                  <div *ngIf="showMarginEdit" class="form-group" id="showMargin">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" (click)="updateQuoteMargin()" i18n>Update</button>
                    </div>
                    <input name="quote_GrossMargin" type="number" id="quote_GrossMargin" class="form-control"
                           [(ngModel)]="quote.quote_GrossMargin" #quote_GrossMargin="ngModel" />
                  </div>
                </td>
              </tr>
              <tr *ngIf="showLinePricing">
                <td i18n>Bid Subtotal:</td>
                <td>
                  <div *ngIf="showBidAmountEdit==false">
                    <a *ngIf="!readOnly" href="javascript:void(0);" (click)="editBid()" i18n>Edit</a>
                    <span class="float-right">${{quote.quote_BidAmount | number: '1.2-2'}}</span>
                  </div>

                  <div *ngIf="showBidAmountEdit" class="form-group" id="show">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" name="editAmount" value="editAmount" (click)="updateBidAmount()" i18n>Update</button>
                    </div>
                    <input name="quote_BidAmount" id="quote_BidAmount" type="text" class="form-control"
                           [(ngModel)]="quote.quote_BidAmount" #quote_BidAmount="ngModel">
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <button *ngIf="!readOnly" (click)="openQuoteTaxDialog()" class="btn btn-bidit-navigate btn-md" i18n>Edit Tax</button>
                  <label *ngIf="readOnly" i18n>Tax Amount:</label>
                </td>
                <td>${{quote.netTax_Total ?? 0 | number: '1.2-2'}}</td>
              </tr>
              <tr>
                <td i18n>Bid Amount:</td>
                <td>${{quoteBidTotalAmount | number: '1.2-2'}}</td>
              </tr>
              <tr *ngIf="showMargins">
                <td i18n>Margin Dollars:</td>
                <td>${{quoteMarginAmount | number: '1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!quote.quote_IsTemplate && !isRequesting && showQuoteAnalysis">
          <button (click)="quoteAnalysis()" class="btn btn-bidit-navigate btn-md" i18n>Quote Analysis</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </div>

    <div *ngIf="!quote.quote_IsTemplate" class="row" align="center">
      <div class="col-12">
        <button (click)="openPrintOptionsDialog()" *ngIf="!isRequesting && !quoteOnly && allowPrint" class="btn btn-bidit-action mr-1" onclick="this.blur();" i18n>Print</button>
        <button (click)="openEmailDialog()" *ngIf="!isRequesting && !quoteOnly  && allowPrint" class="btn btn-bidit-action" onclick="this.blur();" i18n>Send</button>
        <button (click)="acknowledgeQuote(2)" *ngIf="quote.acknowledgementStatus == 'Pending' || quote.acknowledgementStatus == 'Accepted'" class="ml-1 btn btn-bidit-action" onclick="this.blur();" i18n>Reject</button>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </div>
    <div *ngIf="quote.quote_IsTemplate" class="row">
      <div class=" col-sm-9">
        <button (click)="returnToAdmin()" class="btn btn-bidit-submit float-right" i18n>Done</button>
      </div>
    </div>
  </div>
</div>
